/// <amd-module name="SuiteCommerce.Blog.LatestPosts.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.LatestPosts.View", ["require", "exports", "SuiteCommerce.Blog.ExtCarousel.View", "SuiteCommerce.Blog.LatestPosts.Slide.Model.ts", "SuiteCommerce.Blog.LatestPosts.Slide.View", "SuiteCommerce.Blog.Common.Searcher.Helper", "SuiteCommerce.Blog.Post.Collection", "SuiteCommerce.Blog.LatestPosts.Indicator.Model"], function (require, exports, ExtCarousel_View_1, LatestPosts_Slide_Model_1, LatestPosts_Slide_View_1, BlogPostSearcher_Helper_1, Post_Collection_1, LatestPosts_Indicator_View_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var LatestPostsView = /** @class */ (function (_super) {
        __extends(LatestPostsView, _super);
        function LatestPostsView(options) {
            var _this = _super.call(this, options) || this;
            _this.slideContentView = LatestPosts_Slide_View_1.LatestPostsSlideView;
            _this.indicatorContentView = LatestPosts_Indicator_View_1.LatestPostsIndicatorView;
            _this.fetchPostList();
            return _this;
        }
        LatestPostsView.prototype.fetchPostList = function () {
            var _this = this;
            var postsCollection = new Post_Collection_1.PostCollection();
            this.addDummyModel();
            postsCollection
                .fetch(BlogPostSearcher_Helper_1.BlogPostSearcherHelper.buildRequestBody({
                settings: { pageSize: 5, pageNumber: 1 },
                taxonomies: [],
            }))
                .done(function (response) {
                _this.model.slides.reset(response.data.slice(0, 3));
                _this.model.showIndicators = true;
                _this.start();
            });
        };
        LatestPostsView.prototype.addDummyModel = function () {
            this.model.showIndicators = false;
            this.model.slides.add(new LatestPosts_Slide_Model_1.LatestPostsSlideModel());
        };
        return LatestPostsView;
    }(ExtCarousel_View_1.ExtCarouselView));
    exports.LatestPostsView = LatestPostsView;
});
